import type { AuthContext } from '@/contexts/auth-context.tsx';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

interface MyRouterContext {
  auth: AuthContext;
  queryClient: QueryClient;
}

function RootComponent() {
  return (
    <div className="antialiased text-sm overscroll-none">
      <div>
        <Outlet />
      </div>
      {/* <TanStackRouterDevtools position="bottom-left" initialIsOpen={false} /> */}
    </div>
  );
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
});
